import anchorme from 'anchorme';

export const validateUrl = (url: string): boolean => {
  // anchorme.validate.url has been seen to hang if it detects text containing unescaped parentheses as a URL
  let toValidate: string = url;
  if (toValidate?.includes('(') || toValidate?.includes(')')) {
    toValidate = toValidate.replaceAll('(', '%28').replaceAll(')', '%29');
  }
  return anchorme.validate.url(toValidate);
};

// Any app URL parameters that start with this prefix will be included in the `appUrl` parameters data set
// e.g. `myApp?p_Version&p_Environment`
export const USER_PARAM_PREFIX = 'p_';

/**
 * Takes the current URL and extracts all search parameters that start with the USER_PARAM_PREFIX.
 * @returns A record of parameter name string to parameter value string
 */
export const extractAppUrlParameters = (): Record<string, string> => {
  const allQueryParams = new URLSearchParams(window.location.search);
  const appParams: Record<string, string> = {};
  for (const [key, value] of allQueryParams) {
    if (key.startsWith(USER_PARAM_PREFIX)) {
      appParams[key.substring(USER_PARAM_PREFIX.length)] = value;
    }
  }
  return appParams;
};
